import { twMerge } from "tailwind-merge";

type SegmentedControlProps<T extends string> = {
  options: readonly T[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
};

// Equal-width segmented row (chart date ranges, etc.): active segment solid
// raised, inactive hairline-bordered.
function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  className,
}: SegmentedControlProps<T>) {
  return (
    <div className={twMerge("flex gap-1.5", className)}>
      {options.map((option) => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`flex-1 text-center text-[12px] py-1.5 rounded-lg cursor-pointer ${
              active
                ? "font-bold text-ink-primary bg-surface-raised"
                : "font-semibold text-ink-secondary border border-line-subtle"
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
